import { boolean, literal, nativeEnum, object, string, TypeOf } from 'zod';

import { Alignment, ElementType } from '../common';
import { TileOptions } from './tile';

/* --------------------------- SwimlanePageElement -------------------------- */

export const SwimlaneOptions = object({
    name: object({
        alignment: nativeEnum(Alignment),
        visible: boolean(),
    }),
    description: object({
        alignment: nativeEnum(Alignment),
        visible: boolean(),
    }),
    tile: TileOptions,
});

export type SwimlaneOptions = TypeOf<typeof SwimlaneOptions>;

export const SwimlanePageElement = SwimlaneOptions.deepPartial().extend({
    id: string(),
    type: literal(ElementType.Swimlane),
    collectionId: string(),
});

export type SwimlanePageElement = TypeOf<typeof SwimlanePageElement>;
